import { render, staticRenderFns } from "./CommandIf.vue?vue&type=template&id=fd696c20&scoped=true&"
import script from "./CommandIf.vue?vue&type=script&lang=ts&"
export * from "./CommandIf.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd696c20",
  null
  
)

export default component.exports